import React, { createContext, useContext, useEffect, useState } from "react";

const ColorModeContext = createContext();

export function ColorModeProvider({ children }) {
  // Initialize color mode from ls or default to "light"
  const [colorMode, setColorMode] = useState(() => {
    if (typeof window !== "undefined" && window.localStorage) {
      return localStorage.getItem("chakra-ui-color-mode") || "light";
    }
    return "light";
  });

  // Update <html> class and persist mode on change
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove(colorMode === "dark" ? "light" : "dark");
    root.classList.add(colorMode);
    localStorage.setItem("chakra-ui-color-mode", colorMode);
  }, [colorMode]);

  const toggleColorMode = () => {
    setColorMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ColorModeContext.Provider value={{ colorMode, setColorMode, toggleColorMode }}>
      {children}
    </ColorModeContext.Provider>
  );
}

// Hook to consume color mode context
export function useColorMode() {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}

// Hook to select value based on color mode
export function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}